import { Button, Tooltip } from "@mui/material"
import { DeleteSweep } from "@mui/icons-material"

const BulkDeleteButton = ({ options }) => {
  const { handleBulkDelete } = options

  return (
    <Tooltip title="Delete selected items">
      <Button disabled={!options.selectedItems || options.selectedItems.length === 0} color="primary" variant="text" onClick={handleBulkDelete} startIcon={<DeleteSweep />}>
        Bulk Delete
      </Button>
    </Tooltip>
  )
}

export default BulkDeleteButton
